import StatusesApi from "../../../api/statuses-api";
import { StatusTypes } from "../../../constants/status_types";


// initial state
const initialState = () => ({
  isFetching: false,
  statuses: [],
  totals: {}
});

// actions
const actions = {
  getStates: async ({ commit }, payload) => {
    const { totals_only, status_type, with_cow, with_building, active_only, with_heat_index } = payload || {};
    try {
      commit("request", payload);

      const apiResponse = await StatusesApi.get(
        { totals_only, status_type, with_cow, with_building, active_only, with_heat_index }
      );

      if (apiResponse && apiResponse.data) {
        if (totals_only) {
          commit("getTotalsOnlySuccess", apiResponse.data);
        } else {
          commit("getStatesSuccess", apiResponse.data);
        }
      } else {
        commit("getStatesFailed", apiResponse);
      }
    } catch (e) {
      commit("getStatesFailed", e);
    }
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },
  getStatesSuccess: (state, payload) => {
    state.isFetching = false;
    state.statuses = payload;
  },
  getStatesFailed: state => {
    state.isFetching = false;
  },
  getTotalsOnlySuccess: (state, payload) => {
    
    const totals = {
      ...payload,
      allCows: 0,
      lactating: 0,
      nonLactating: 0
    };

    Object.entries(payload).forEach(([k, v]) => {
      totals.allCows += v;
      if(k === StatusTypes.Dry) {
        totals.nonLactating += v;
      } else {
        totals.lactating += v;
      }
    })

    state.isFetching = false;
    state.totals = totals;
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/states.js